// src/pages/FreeHomeDelivery.js
import React from 'react';
import Service from '../components/Service';
const Services= () => {
  return (
<Service/>
  );
};

export default Services;
